// extracted by mini-css-extract-plugin
export default {"Navback":"nav-bar_Navback__C2koV","Wrapper":"nav-bar_Wrapper__Wqg7f"};